/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecurrenceSchedule } from './RecurrenceSchedule';
import {
    RecurrenceScheduleFromJSON,
    RecurrenceScheduleFromJSONTyped,
    RecurrenceScheduleToJSON,
    RecurrenceScheduleToJSONTyped,
} from './RecurrenceSchedule';

/**
 * Configuration for recurring competitions
 * @export
 * @interface RecurrenceConfig
 */
export interface RecurrenceConfig {
    /**
     * 
     * @type {RecurrenceSchedule}
     * @memberof RecurrenceConfig
     */
    schedule: RecurrenceSchedule;
    /**
     * Day of week for weekly recurrence (e.g., "Saturday")
     * @type {string}
     * @memberof RecurrenceConfig
     */
    dayOfWeek?: string;
    /**
     * Time of day (e.g., "8pm EST")
     * @type {string}
     * @memberof RecurrenceConfig
     */
    time?: string;
    /**
     * Custom cron expression for CUSTOM schedule
     * @type {string}
     * @memberof RecurrenceConfig
     */
    cronExpression?: string;
}



/**
 * Check if a given object implements the RecurrenceConfig interface.
 */
export function instanceOfRecurrenceConfig(value: object): value is RecurrenceConfig {
    if (!('schedule' in value) || value['schedule'] === undefined) return false;
    return true;
}

export function RecurrenceConfigFromJSON(json: any): RecurrenceConfig {
    return RecurrenceConfigFromJSONTyped(json, false);
}

export function RecurrenceConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurrenceConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'schedule': RecurrenceScheduleFromJSON(json['schedule']),
        'dayOfWeek': json['dayOfWeek'] == null ? undefined : json['dayOfWeek'],
        'time': json['time'] == null ? undefined : json['time'],
        'cronExpression': json['cronExpression'] == null ? undefined : json['cronExpression'],
    };
}

export function RecurrenceConfigToJSON(json: any): RecurrenceConfig {
    return RecurrenceConfigToJSONTyped(json, false);
}

export function RecurrenceConfigToJSONTyped(value?: RecurrenceConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'schedule': RecurrenceScheduleToJSON(value['schedule']),
        'dayOfWeek': value['dayOfWeek'],
        'time': value['time'],
        'cronExpression': value['cronExpression'],
    };
}

